import { PatronEditBooking } from "@/screens/BookingDetail/NewPatronBookingFlow/components/EditBooking/types";

type Args = {
  booking: PatronEditBooking.Booking | null | undefined;
  currentRound: PatronEditBooking.Round | null | undefined;
  isTargetingAll: boolean;
};

export const getTargetTransportationRoundIds = ({
  booking,
  currentRound,
  isTargetingAll,
}: Args): string[] | undefined => {
  if (!isTargetingAll || !booking || !currentRound) {
    return undefined;
  }
  return booking.rounds.map((round) => round.localId);
};
